module.exports = __webpack_public_path__ + "static/media/BANDHAN.28d77d2c.svg";